import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { ThemeProvider } from './context/ThemeContext';
import HomePage from './pages/HomePage';
import CareerDetailPage from './components/CareerDetailPage';
import BlogPosts from './pages/BlogPosts';
import BlogPostDetailPage from './components/BlogPostDetailPage';
import Poetry from './pages/Poetry';
import PoetryDetailPage from './components/PoetryDetailPage';
import OldRulesNewTools from './pages/OldRulesNewTools';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/career/:id" element={<CareerDetailPage />} />
          <Route path="/blog" element={<BlogPosts />} />
          <Route path="/blog/:id" element={<BlogPostDetailPage />} />
          <Route path="/poetry" element={<Poetry />} />
          <Route path="/poetry/:id" element={<PoetryDetailPage />} />
          <Route path="/coc3.0" element={<OldRulesNewTools />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;